import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { typeChanged } from "../features/jobsFilter/jobsFilterSlice";

export default function Sidebar() {
  const dispatch = useDispatch();
  const { type } = useSelector((state) => state.jobsFilter);
  const handleInternship = () => {
    dispatch(typeChanged("Internship"));
  };
  const handleRemote = () => {
    dispatch(typeChanged("Remote"));
  };
  const handleFulltime = () => {
    dispatch(typeChanged("Full time"));
  };
  const handleAllJobs = () => {
    dispatch(typeChanged(""));
  };
  return (
    <div className="sidebar">
      <nav>
        <ul className="space-y-4">
          <li>
            <Link
              to="/"
              className={`main-menu ${type === "" && "menu-active"} lws-allJob`}
              onClick={handleAllJobs}
            >
              <i className="fa-solid fa-briefcase"></i>
              <span> All Available Jobs</span>
            </Link>
            <ul className="space-y-6 lg:space-y-2 ">
              <li>
                <Link
                  to="/"
                  className={`sub-menu ${
                    type === "Internship" && "menu-active"
                  }`}
                  onClick={handleInternship}
                >
                  <i className="fa-solid fa-stop !text-[#FF5757]"></i>{" "}
                  Internship
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className={`sub-menu ${
                    type === "Full time" && "menu-active"
                  }`}
                  onClick={handleFulltime}
                >
                  <i className="fa-solid fa-stop !text-[#FF8A00]"></i> Full Time
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className={`sub-menu ${type === "Remote" && "menu-active"}`}
                  onClick={handleRemote}
                >
                  <i className="fa-solid fa-stop !text-[#56E5C4]"></i> Remote
                </Link>
              </li>
            </ul>
          </li>
          <li>
            <Link to="/addNewJob" className="main-menu lws-AddJob">
              <i className="fa-solid fa-file-circle-plus"></i>{" "}
              <span>Add NewJob</span>
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  );
}
